<div class="hero-section">
        <div class="hero-background">
        <img
            class="hero-image"
            src="assets/hero-south-indian-thali.jpg"
            alt="South Indian banana-leaf meal with dosa, idli, sambar and chutneys">
        <div class="hero-overlay"></div>
    </div>
    
    <div class="hero-content">
        <div class="hero-badge">Authentic South Indian Cuisine</div>
        <h1 class="hero-title">Where Tradition Meets Taste</h1>
        <p class="hero-description">Unaavu in Tamil means food. Actually, it is more than just food — it is a return to roots, a celebration of local wisdom, and a daily ritual of nourishment. We serve wholesome, plant-based South Indian meals prepared using age-old methods.</p>
        <button mat-raised-button color="primary" class="hero-cta" (click)="onClickNavigate()">Explore Menu</button>
    </div>
</div>

<div class="page-container">
    <section class="about-section">
        <h2 class="section-title">Our Story</h2>
        <p class="section-text">Born in Jodhpur with roots deep in Tamil Nadu, Unaavu brings South India's soul to Rajasthan's plate. What began as a personal longing for home-cooked Tamil flavors grew into a refined culinary experience. Every dish tells a story of tradition, care and quiet pride.</p>
    </section>

    <section class="cta-section">
        <h2 class="section-title">What would you like to do?</h2>
        <div class="action-cards-grid">
            <div class="action-card" (click)="selectActionAndNavigate('Order for Delivery')">
                <div class="card-icon" aria-hidden="true">
                    <svg width="56" height="56" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 3h11v13H3z" fill="#46664b" opacity="0.15"/>
                        <path d="M16 8h3l2 3v5" stroke="#46664b" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5 16a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z" fill="#46664b"/>
                        <path d="M16 8v8" stroke="#46664b" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <h3>Order for Delivery</h3>
                <p>Get delicious meals delivered to your doorstep</p>
            </div>

            <div class="action-card" (click)="selectActionAndNavigate('Order Take Away')">
                <div class="card-icon" aria-hidden="true">
                    <svg width="56" height="56" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3 7h18v2H3z" fill="#46664b" opacity="0.12"/>
                        <path d="M7 9l1 9h8l1-9" stroke="#46664b" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M10 4h4l1 5H9l1-5z" stroke="#46664b" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <h3>Order Take Away</h3>
                <p>Pick up your order at your convenience</p>
            </div>

            <div class="action-card" (click)="selectActionAndNavigate('Book a Table')">
                <div class="card-icon" aria-hidden="true">
                    <svg width="56" height="56" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 7h16v2H4z" fill="#46664b" opacity="0.12"/>
                        <path d="M7 9v6" stroke="#46664b" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M17 9v6" stroke="#46664b" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M2 20h20" stroke="#46664b" stroke-width="1.2" stroke-linecap="round"/>
                    </svg>
                </div>
                <h3>Book a Table</h3>
                <p>Dine in our cozy restaurant</p>
            </div>

            <div class="action-card" (click)="selectActionAndNavigate('Order At Table')">
                <div class="card-icon" aria-hidden="true">
                    <svg width="56" height="56" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 2v8" stroke="#46664b" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16 2v8" stroke="#46664b" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M4 20h16v-2H4v2z" fill="#d4a574" opacity="0.12"/>
                        <path d="M8 14h8v6H8z" stroke="#46664b" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <h3>Order At Table</h3>
                <p>Order directly while dining with us</p>
            </div>

            @if (hasTrackingJwt()) {
            <div class="action-card" (click)="selectActionAndNavigate('My Orders')">
                <div class="card-icon" aria-hidden="true">
                    <svg width="56" height="56" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="4" y="3" width="16" height="18" rx="2" fill="#46664b" opacity="0.08"/>
                        <path d="M8 8h8M8 12h8M8 16h5" stroke="#46664b" stroke-width="1.4" stroke-linecap="round"/>
                        <path d="M15.5 18.5l2 2 3.5-3.5" stroke="#46664b" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <h3>My Orders</h3>
                <p>View your orders and track their latest status</p>
            </div>
            }
        </div>
    </section>

    <section class="testimonials-section">
        <h2 class="section-title">What guests say</h2>
        @if (lastOrder(); as order) {
            <div class="review-nudge-wrap">
                <app-review-nudge
                    [orderId]="order._id ?? null"
                    [dishNames]="lastOrderDishNames()"
                    [guestNameHint]="loggedInGuestName()" />
            </div>
        }
        @if (testimonials().length === 0) {
            <div class="empty-panel">
                <p>Stories from the dining room will appear here.</p>
            </div>
        } @else {
            <div class="testimonials-grid">
                @for (review of testimonials(); track review._id) {
                    <article class="testimonial-card">
                        <div class="testimonial-header">
                            <app-reviewer-avatar
                                [name]="review.guestName"
                                [photoUrl]="review.pictureUrl ?? null"
                                size="lg" />
                            <div class="testimonial-identity">
                                <p class="author">{{ review.guestName }}</p>
                                <p class="stars" [attr.aria-label]="review.rating + ' out of 5 stars'">{{ starLabel(review.rating) }}</p>
                            </div>
                        </div>
                        <p class="quote-mark" aria-hidden="true">“</p>
                        <p class="quote">{{ review.comment }}</p>
                    </article>
                }
            </div>
            <div class="section-cta">
                <button mat-stroked-button type="button" (click)="goToReviews()">Read all reviews</button>
            </div>
        }
    </section>

    <section class="gallery-preview-section">
        <h2 class="section-title">From our events</h2>
        @if (galleryPreview().length === 0) {
            <div class="empty-panel">
                <p>Event photos will appear here as we add them from the kitchen and dining room.</p>
                <button mat-stroked-button type="button" (click)="goToGallery()">Open gallery</button>
            </div>
        } @else {
            <div class="gallery-preview-grid">
                @for (item of galleryPreview(); track item._id) {
                    <button type="button" class="gallery-preview-tile" (click)="goToGallery()">
                        @if (item.kind === 'video') {
                            <video [src]="item.mediaUrl" muted playsinline></video>
                        } @else {
                            <img [src]="item.mediaUrl" [alt]="item.title" />
                        }
                    </button>
                }
            </div>
            <div class="section-cta">
                <button mat-stroked-button type="button" (click)="goToGallery()">View gallery</button>
            </div>
        }
    </section>
</div>
